/**
 * Nazwa drogi pokazywana osobie decydującej (przyciski dróg, okno „Akceptacja").
 *
 * Kolejność zastępstw jest ta sama co na serwerze (`listAvailableRoutes`): własna nazwa drogi →
 * nazwa etapu docelowego → tekst zastępczy („Droga bez nazwy"). Serwer podstawia nazwę etapu
 * docelowego już w `AvailableRoute.label`; tu drugi bezpiecznik, gdyby `label` przyszedł pusty.
 */

import type { AvailableRoute } from '@saas/shared';

export function routeDisplayLabel(
  route: Pick<AvailableRoute, 'label' | 'targetLabel'>,
  unnamedLabel: string,
): string {
  return route.label.trim() || route.targetLabel?.trim() || unnamedLabel;
}
